/**
 * adminFetch — fetch wrapper that injects the Admin Bearer token.
 * Drop-in replacement for window.fetch in admin pages.
 */
import adminAuthService from './adminAuthService';

export async function adminFetch(url, options = {}) {
  const token = adminAuthService.getAccessToken();
  const headers = new Headers(options.headers || {});
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  const res = await fetch(url, { ...options, headers });

  // 401 → try refresh once
  if (res.status === 401) {
    try {
      const newToken = await adminAuthService.refresh();
      headers.set('Authorization', `Bearer ${newToken}`);
      return fetch(url, { ...options, headers });
    } catch (_) {
      adminAuthService.clear();
      window.location.href = '/admin/login';
      throw new Error('Session expired');
    }
  }
  return res;
}

export default adminFetch;
